import React from "react";
import { Row, Col } from "reactstrap";

const ContactUs = () => {
  return (
    <Row className="pr-0 pl-0 psInfo">
      <Col>
        <h2 className="text-center text-uppercase">Court information</h2>
        <hr />
        <Row className="padTop">
          <Col md={12}>
            <Row>
              <Col xl={1}>
                <span>Address: </span>
              </Col>
              <Col>
                <span>
                  401 W. Washington St., Suite 130, SPC 1 Phoenix, AZ 85003-2118
                </span>
              </Col>
            </Row>
            <Row>
              <Col xl={1}>
                <span>Courthouse: </span>
              </Col>
              <Col>
                <span>
                  7:30 a.m. - 5:30 p.m. M-F, excluding court-observed holidays
                </span>
              </Col>
            </Row>
            <Row>
              <Col xl={1}>
                <span>Phone:</span>
              </Col>
              <Col>
                {
                  <span>
                    602-258-3434 – ext 3422
                  </span> /* <span>602-322-7230</span> */
                }
              </Col>
            </Row>
            <Row>
              <Col xl={1}>
                <span>Email:</span>
              </Col>
              <Col>
                <span>
                  <a href="mailto:FedCrtClinic@clsaz.org?subject=Advice-Only Clinic Questions">
                    FedCrtClinic@clsaz.org
                  </a>
                </span>
                {/* <span>
                  <a href="mailto:AdviceOnlylinic@azd.uscourts.gov?subject=Advice-Only Clinic Questions">
                    adviceonlyclinic@azd.uscourts.gov
                  </a>
                </span> */}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="padTop">
          <Col md={12}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6658.114957172447!2d-112.08024!3d33.447809!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b12267e1a59c3%3A0xe9f11e9addcd1619!2sSandra%20Day%20O&#39;Connor%20U.S.%20Courthouse!5e0!3m2!1sen!2sus!4v1582906146102!5m2!1sen!2sus"
              className="mapCust"
              title="Google map to courthouse"
            ></iframe>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default ContactUs;
